import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import styles from './styles.module.scss'

export default function SocialLinks({ messenger, linkedin, instagram }) {
  const { profileData, userStatus } = useSelector((state) => state.myProfile)

  return (
    <div className={`${styles.socialLinks}`}>
      {messenger && userStatus !== 'deactivated' && userStatus !== 'deleted' && (
        <Link to={`/0/messenger/?userid=${profileData.user.id}`}>
          <div className={`${styles.icons}`}>
            <img src={`${config.assetUrl}${'/images/writeMessage-roundButton.svg'}`} alt='messenger' />
          </div>
        </Link>
      )}
      {linkedin && (
        <a href={profileData.user.linkedIn_url} target='_blank'>
          <div className={`${styles.icons}`}>
            <img src={`${config.assetUrl}${'/images/linkedin-roundbtn.svg'}`} alt='linkedin' />
          </div>
        </a>
      )}
      {instagram && (
        <a href={profileData.user.instagram_url} target='_blank'>
          <div className={`${styles.icons}`}>
            <img src={`${config.assetUrl}${'/images/ig-roundbtn.svg'}`} alt='instagram' />
          </div>
        </a>
      )}
    </div>
  )
}
